import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { errorNotify } from 'app/store/common-effects/notifier.effects';
import { SetStateProperties } from 'app/store/completed-entity-state/completed-entity-state';
import { ownedError } from 'core/utils/owned-error';
import { cacheable, projectScopedRequest } from 'core/utils/rx-common';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { defer, EMPTY, Observable, of } from 'rxjs';
import { catchError, finalize, tap, throwIfEmpty } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CompletedEntityStateService {
  constructor(
    private store$: Store,
    private dbService: NgxIndexedDBService,
  ) {}

  get<T>(properties: SetStateProperties<T>): Observable<T> {
    return defer(() => {
      this.store$.dispatch(properties.setLoading({ value: true }));
      this.store$.dispatch(properties.setError({ value: null }));

      return projectScopedRequest(this.store$, () => defer(() => properties.cacheKey
        ? of(undefined).pipe(cacheable(properties.cacheKey, this.store$, this.dbService, () => properties.request()))
        : properties.request()).pipe(
        throwIfEmpty(() => ownedError(new Error('Request completed without data'))),
        catchError((error: unknown) => {
          const requestError = error instanceof Error || error instanceof HttpErrorResponse
            ? error
            : ownedError(new Error('Request completed without data'));
          this.store$.dispatch(properties.setError({ value: requestError }));
          this.store$.dispatch(errorNotify({ message: 'NOTIFICATIONS.load_failed' }));
          return EMPTY;
        }),
        tap(() => this.store$.dispatch(properties.setLoaded())),
      ));
    }).pipe(
      finalize(() => this.store$.dispatch(properties.setLoading({ value: false }))),
    );
  }
}
